<script>
import { ref } from "vue";
import { useLog } from "../../../../../../../services/hooks";

export default {
  name: "SelectedNotaryComponent",
  props: {
    currentNotaryName: {
      type: String,
      required: true
    },
    currentNotaryRegion: {
      type: String,
      required: true
    },
    notarialCaseNumber: {
      type: String
    },
    setNotarialCaseNumber: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const caseNumber = ref('');
    const setNotarialCaseNumber = props.setNotarialCaseNumber;
    const { recordLog }  = useLog();

    const handleChange = (e) => {
      setNotarialCaseNumber(caseNumber.value);
      recordLog('Ручной ввод нотариального дела (' + caseNumber.value + ')');
    };

    return {
      handleChange,
      caseNumber
    }
  }
}
</script>

<template>
  <div class="selected-notary">
    <div>
      <label>Выбран нотариус: </label>
      <span class="blue">
        {{ currentNotaryName }} ({{ currentNotaryRegion }})
      </span>
    </div>
    <div class="notary-setting">
      <div class="form-group">
        <h4>Укажите № наследственного дела, если он Вам известен:</h4>
      </div>
      <div class="form-group">
        {{ caseNumber.value }}
        <input
          type="text"
          class="form-control"
          placeholder="№ насл.дела"
          v-model="caseNumber"
          @change="handleChange"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

.selected-notary {
  margin-top: 5px;
  padding: 10px;
  border: 1px dashed #a5a5a5;
}

.selected-notary label {
  font-weight: bold;
  margin-bottom: 5px;
  display: inline-block;
  margin-right: 5px;
}

.notary-setting {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.notary-setting .form-group:first-child {
  width: 71%;
}

.notary-setting .form-group:last-child {
  width: 29%;
}

.notary-setting h4 {
  margin-bottom: 3px;
  font-weight: normal;
}

@media (max-width: 768px) {

  .notary-setting {
    display: block;
  }

  .notary-setting .form-group:first-child,
  .notary-setting .form-group:last-child {
    width: 100%;
  }

}

</style>
